import React from 'react';
import { SketchPicker } from 'react-color';
import onClickOutside from 'react-onclickoutside';

import './styles.less';

class ColorPicker extends React.PureComponent {
  static defaultProps = {
    onClickOutside: () => {}, // Callback for clicking outside of dropdown component
    show: false, // Toggle visiblity
    className: '', // Applies to root element
  };

  state = {
    left: undefined,
  };

  render() {
    const { className, ...props } = this.props;

    const style = {
      left: this.state.left,
    };

    return (
      <div
        ref={ref => (this.root = ref)}
        style={style}
        className={`color-picker${this.props.show ? ' show' : ''} ${className}`}
      >
        <SketchPicker {...props} />
      </div>
    );
  }

  componentDidMount() {
    this.moveIntoView();
  }

  componentDidUpdate(prevProps) {
    // Double-check placement after potential responsive design change
    if (prevProps.show != this.props.show) {
      this.moveIntoView();
    }
  }

  moveIntoView = () => {
    const { width, left } = this.root.getBoundingClientRect();
    const { width: scrollWidth } = document.body.getBoundingClientRect();

    // We must calculate the would-be left of the drop down to determine if there's room for it
    // If there's no room, we'll shift it only as much as needed
    const unadjustedLeft = left + -1 * (this.state.left || 0);
    const overflowOnRight = unadjustedLeft + width - scrollWidth;

    if (overflowOnRight > 0) {
      this.setState({
        left: -overflowOnRight,
      });
    } else {
      this.setState({
        left: undefined,
      });
    }
  };

  handleClickOutside = (...args) => {
    this.props.onClickOutside(...args);
  };
}

export default onClickOutside(ColorPicker);
